import './App.css'
import {JanusEcho} from "./JanusEcho.tsx";

const App = () => (
    <>
        <header id="banner" role="banner" className="banner">
            <h1 className="page-header">Welcome to the WebApp Playground</h1>
        </header>
        <article id="sign-board" className="sign-board">
            <JanusEcho />
        </article>
    </>
);

export default App
